import { render, staticRenderFns } from "./burger_menu.vue?vue&type=template&id=60d55c84&scoped=true&"
import script from "./burger_menu.vue?vue&type=script&lang=js&"
export * from "./burger_menu.vue?vue&type=script&lang=js&"
import style0 from "./burger_menu.vue?vue&type=style&index=0&id=60d55c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d55c84",
  null
  
)

export default component.exports